import { useEffect, useRef, useCallback } from 'react';

/**
 * Listens on /ws/queue for real-time queue change events.
 * Calls `onUpdate` whenever the server signals a change.
 */
export function useQueueUpdates(onUpdate) {
  const wsRef = useRef(null);
  const cbRef = useRef(onUpdate);
  cbRef.current = onUpdate;

  const connect = useCallback(() => {
    const protocol = window.location.protocol === 'https:' ? 'wss' : 'ws';
    const ws = new WebSocket(`${protocol}://${window.location.host}/ws/queue`);

    ws.onmessage = () => {
      cbRef.current?.();
    };
    ws.onclose = () => {
      setTimeout(connect, 3000);
    };
    ws.onerror = () => ws.close();

    wsRef.current = ws;
  }, []);

  useEffect(() => {
    connect();
    return () => {
      if (wsRef.current) wsRef.current.close();
    };
  }, [connect]);
}
